<template>
  <div class="recharge">
    <Navbar :title="$t('newAdd.Recharge')" />
    <div class="content-wrap">
      <div class="padding16">
        <div class="content">
          <div class="payNum font14">
            <span class="label">{{ $t("newAdd.RechargeAmount") }}</span>
            <div class="value font22">{{ payData.money }}</div>
          </div>
          <div class="width100pre payNum">
            <div class="font14 address-wrap label">
              {{ $t("newAdd.depositAddress") }}：
            </div>
            <div class="address_value_wrap" @click="copy">
              <div class="flex center-hor" v-if="!!payData.qrimg">
                <van-image width="150px" height="150px" :src="payData.qrimg" />
              </div>
              <div class="url">
                <div class="url_value font14">{{ payData.url }}</div>
                <div class="copy">
                  <svg t="1651894560362" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="1900" width="18" height="18">
                    <path
                      d="M878.250667 981.333333H375.338667a104.661333 104.661333 0 0 1-104.661334-104.661333V375.338667a104.661333 104.661333 0 0 1 104.661334-104.661334h502.912a104.661333 104.661333 0 0 1 104.661333 104.661334v502.912C981.333333 934.485333 934.485333 981.333333 878.250667 981.333333zM375.338667 364.373333a10.666667 10.666667 0 0 0-10.922667 10.965334v502.912c0 6.229333 4.693333 10.922667 10.922667 10.922666h502.912a10.666667 10.666667 0 0 0 10.922666-10.922666V375.338667a10.666667 10.666667 0 0 0-10.922666-10.922667H375.338667z"
                      p-id="1901" fill="var(--theme)"></path>
                    <path
                      d="M192.597333 753.322667H147.328A104.661333 104.661333 0 0 1 42.666667 648.661333V147.328A104.661333 104.661333 0 0 1 147.328 42.666667H650.24a104.661333 104.661333 0 0 1 104.618667 104.661333v49.962667c0 26.538667-20.309333 46.848-46.848 46.848a46.037333 46.037333 0 0 1-46.848-46.848V147.328a10.666667 10.666667 0 0 0-10.922667-10.965333H147.328a10.666667 10.666667 0 0 0-10.965333 10.965333V650.24c0 6.229333 4.693333 10.922667 10.965333 10.922667h45.269333c26.538667 0 46.848 20.309333 46.848 46.848 0 26.538667-21.845333 45.312-46.848 45.312z"
                      p-id="1902" fill="var(--theme)"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="coin_amount_wrap font14 top6">
            <span class="label">
              {{ `${coinConfig.type} ${$t("newAdd.Amount")}` }}：
            </span>
            <span class="value font14">
              {{ `≈${coinAmount} ${coinConfig.type}` }}
            </span>
            <span class="coin_copy" @click="coinCopy">
              <svg t="1651894560362" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1900" width="18" height="18">
                <path
                  d="M878.250667 981.333333H375.338667a104.661333 104.661333 0 0 1-104.661334-104.661333V375.338667a104.661333 104.661333 0 0 1 104.661334-104.661334h502.912a104.661333 104.661333 0 0 1 104.661333 104.661334v502.912C981.333333 934.485333 934.485333 981.333333 878.250667 981.333333zM375.338667 364.373333a10.666667 10.666667 0 0 0-10.922667 10.965334v502.912c0 6.229333 4.693333 10.922667 10.922667 10.922666h502.912a10.666667 10.666667 0 0 0 10.922666-10.922666V375.338667a10.666667 10.666667 0 0 0-10.922666-10.922667H375.338667z"
                  p-id="1901" fill="var(--theme)"></path>
                <path
                  d="M192.597333 753.322667H147.328A104.661333 104.661333 0 0 1 42.666667 648.661333V147.328A104.661333 104.661333 0 0 1 147.328 42.666667H650.24a104.661333 104.661333 0 0 1 104.618667 104.661333v49.962667c0 26.538667-20.309333 46.848-46.848 46.848a46.037333 46.037333 0 0 1-46.848-46.848V147.328a10.666667 10.666667 0 0 0-10.922667-10.965333H147.328a10.666667 10.666667 0 0 0-10.965333 10.965333V650.24c0 6.229333 4.693333 10.922667 10.965333 10.922667h45.269333c26.538667 0 46.848 20.309333 46.848 46.848 0 26.538667-21.845333 45.312-46.848 45.312z"
                  p-id="1902" fill="var(--theme)"></path>
              </svg>
            </span>
          </div> -->
        </div>
        <div class="uploads">
          <div class="upload_title">{{ $t('上传证明') }}</div>
          <div class="upload_img">
            <van-uploader v-model="cert" :after-read="card_frontUpload" :show-upload="cert.length === 0"
              :deletable="status === 0" @delete="deleteImage('cert')" />
          </div>
        </div>
        <div class="step-wrap top16">
          <div class="font14">{{ $t("newAdd.rechargeSteps") }}：</div>
          <div class="font12 line1 top10">
            <div v-for="(item, index) in steps" :key="index">
              {{ index + 1 }}.{{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed btn-wrap flex">
      <!-- <div class="right" @click="downloadQr">
        {{ $t("newAdd.rechargeNow") }}
      </div> -->
      <div class="left" @click="confirm" style="width: 100%">
        {{ $t("newAdd.completePayment") }}
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, NavBar, Image as VanImage, Toast, Uploader } from "vant";
import download from "downloadjs";
import { RECHARGE_COMMIT } from "@/api";
import Navbar from "@/components/JNav";
import { $upload } from "@/utils/request.js";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Uploader.name]: Uploader,
    Toast,
    Navbar,
  },
  data() {
    return {
      payData: {},
      steps: [],
      coinConfig: {},
      coinAmount: "0.00",
      imageType: "png",
      cert: [],
      status: 0
    };
  },
  methods: {
    deleteImage(which) {
      (this[which] = []), (this.payData[which] = "");
    },
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = function (e) {
          img.src = e.target.result;
        };
        reader.onerror = function (e) {
          reject(e);
        };
        reader.readAsDataURL(file);
        img.onload = function () {
          resolve(img);
        };
        img.onerror = function (e) {
          reject(e);
        };
      });
    },
    async compressImg(file) {
      const img = await this.readImg(file);
      const type = img.type;
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const { width: originWidth, height: originHeight } = img;
        // 最大尺寸限制
        const maxWidth = 1000;
        const maxHeight = 1000;
        // 目标尺寸
        let targetWidth = originWidth;
        let targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            //  宽图片
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            // 高图片
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, type || "image/png");
      });
    },
    async card_frontUpload(event) {
      event.status = "uploading";
      event.message = this.$t("upload.uploading");
      const formdata = new FormData();
      try {
        const ImgData = await this.compressImg(event.file);
        const fileData = new File([ImgData], event.file.name, {
          type: ImgData.type,
        });
        formdata.append("image", fileData);
      } catch (error) {
        formdata.append("image", event.file);
      }
      $upload({ url: "/users/upload", data: formdata })
        .then((res) => {
          if (res.ret === 1) {
            event.status = "success";
            event.message = "";
            this.payData.cert = res.data.path;
          } else {
            event.status = "failed";
            event.message = this.$t("upload.failed");
          }
        })
        .catch((err) => {
          event.status = "failed";
          event.message = this.$t("upload.failed");
          // this.$toast(this.$t("uploadErr"));
        });
    },
    downloadQr() {
      this.imageType = this.payData.qrimg.substring(
        this.payData.qrimg.length - 3
      );
      Toast(this.$t("newAdd.toCutScreen"));
      // download(this.payData.qrimg, `myCode.${this.imageType}`, "image");
    },
    copy() {
      this.$copyText(this.payData.url).then((e) => {
        Toast("Copy successfully");
      });
    },
    coinCopy() {
      this.$copyText(this.coinAmount).then((e) => {
        Toast("Copy successfully");
      });
    },
    confirm() {
      if (!this.payData.cert) return Toast(this.$t('请上传证明'));
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      RECHARGE_COMMIT({
        id: this.payData.id,
        money: this.payData.money,
        account: this.payData.account,
        cert: this.payData.cert,
        isbefore: 1,
      })
        .then((r) => {
          Toast.clear();
          if (r.data.ret === 1) {
            Toast.clear();
            // Toast
            // this.$router.back();
            this.$router.push('/recharge-list?type=qr');
            // window.location.href = r.data.data.url;
          } else {
            // Toast('System exception, please try again later')
            Toast(r.data.msg);
          }
        })
        .catch((e) => {
          Toast.clear();
          console.error(e);
        });
    },
    fixed(num, digits) {
      const dig = 10 ** digits;
      const res = Math.round(num * dig) / dig;
      return res > 0 && !!res ? res : "0.00";
    },
  },
  created() {
    let payData = this.$route.params.payData;
    if (payData) {
      this.payData = payData;
      this.$cookie.set("qrPayData", JSON.stringify(this.payData));
    } else {
      this.payData = JSON.parse(this.$cookie.get("qrPayData"));
    }
    this.steps = this.payData.step.split(/[0-9]./);
    for (let i = 0; i < this.steps.length; i++) {
      let item = this.steps[i];
      if (item == "") {
        this.steps.splice(i, 1);
      }
    }
    this.coinConfig = this.payData.setting;
    this.coinAmount = this.fixed(
      this.payData.money / this.coinConfig.coin_rate,
      8
    );
  },
  mounted() { }
};
</script>

<style lang="less" scoped>
@Color: var(--theme);
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
// @comBG: #07304a;
@comBG: var(--bg1);

.recharge {
  position: relative;
  height: 100%;
  min-height: calc(100vh - 3rem);
  padding-bottom: 3rem;
  overflow: hidden;
  background: var(--light);

  .label {
    color: #333;
  }

  .value {
    color: var(--navBg);
  }

  .step-wrap {
    color: grey;
    background: #F7F8FA;
    min-height: 50px;
    border-radius: 10px;
    padding: 12px;
  }

  .content-wrap {
    // width: 100vw;
    // min-height: 100vh;
    position: relative;
    overflow: hidden;

    .content {
      .payNum {
        .lable {
          color: #3D3D3D;
          line-height: 1;
        }

        .value {
          background: #F7F8FA;
          text-align: center;
          font-size: 18px;
          height: 50px;
          line-height: 50px;
          border-radius: 10px;
          margin: 10px 0 16px;
          font-weight: bold;
          color: var(--theme);
        }

        .address_value_wrap {
          background: #F7F8FA;
          font-size: 18px;
          padding: 20px;
          margin-top: 10px;
          border-radius: 10px;

          .url {
            .url_value {
              width: calc(100% - 2.5rem );
              word-break: break-all;
              color: var(--theme);
              margin: 20px auto 0;
            }
            .copy{
              display: flex;
              align-items: center;
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }
}


.coin_amount_wrap {
  display: flex;

  >.coin_copy {
    margin-left: 1rem
      /* 16/16 */
    ;
  }
}

.uploads {
  .upload_title {
    font-size: 16px;
    color: #333;
    margin: 16px 0;
  }

  .upload_img {
    /deep/ .van-uploader__upload {
      width: calc(110rem / 16);
      height: calc(110rem / 16);
    }

    /deep/ .van-uploader__preview-image {
      width: calc(110rem / 16);
      height: calc(110rem / 16);
    }

    /deep/ .van-uploader__preview-delete {
      width: 20px;
      height: 20px;

      .van-uploader__preview-delete-icon {
        font-size: 22px;
      }
    }
  }
}
</style>

<style scoped>
.top10 {
  margin-top: 0.625rem;
}

.top6 {
  margin-top: 0.375rem;
}

.top16 {
  margin-top: 1rem;
}

.padding16 {
  padding: 1rem;
}

.padding10 {
  padding: 0.625rem;
}

.white-back {
  background-color: #fff;
}

.font12 {
  font-size: 0.75rem;
}

.font14 {
  font-size: 0.875rem;
}

.font16 {
  font-size: 1rem;
}

.font18 {
  font-size: 1.125rem;
}

.font22 {
  font-size: 1.375rem;
}

.color-red {
  color: #ff0000;
}

.flex {
  display: flex;
}

.between {
  justify-content: space-between;
}

.width100pre {
  width: 100%;
}

.address-wrap {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy {}

.center-ver {
  align-items: center;
}

.center-hor {
  justify-content: center;
}

.line1 {
  line-height: 1.1;
}

.fixed {
  position: fixed;
}

.btn-wrap {
  bottom: 0;
  width: 100vw;
  max-width: 648px;
}

.btn-wrap>.left,
.right {
  width: 50vw;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--light);
}

.btn-wrap>.left {
  /* background-color: #3eb3ff; */
  background: var(--navBg);
}

.btn-wrap>.right {
  background-color: #dc1323;
}
</style>